function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1613",
  "data-name": "Group 1613",
  transform: "translate(-1394.641 -159.106)"
}, React.createElement("path", {
  id: "Path_1378",
  "data-name": "Path 1378",
  d: "M83.786,119.012C48.338,119.012,0,72.635,0,36.093S27.534,0,62.982,0,141.49,13.945,141.49,50.486,119.234,119.012,83.786,119.012Z",
  transform: "matrix(0.799, -0.602, 0.602, 0.799, 1394.64, 244.258)",
  fill: "rgba(76,186,192,0.15)"
}), React.createElement("g", {
  id: "paper_copy",
  "data-name": "paper copy",
  transform: "matrix(0.996, -0.087, 0.087, 0.996, 1439.231, 174.429)"
}, React.createElement("rect", {
  id: "Rectangle_803",
  "data-name": "Rectangle 803",
  width: 71.147,
  height: 88.489,
  transform: "translate(5.865 5.865)",
  fill: "#fff",
  stroke: "#e5e5e5",
  strokeWidth: 1
}), React.createElement("rect", {
  id: "Rectangle_804",
  "data-name": "Rectangle 804",
  width: 71.147,
  height: 88.489,
  transform: "translate(0 0)",
  fill: "#fff",
  stroke: "#e5e5e5",
  strokeWidth: 1
}), React.createElement("rect", {
  id: "Rectangle_805",
  "data-name": "Rectangle 805",
  width: 54.943,
  height: 2.817,
  transform: "translate(7.931 17.85)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_806",
  "data-name": "Rectangle 806",
  width: 14.084,
  height: 2.817,
  transform: "translate(28.178 10.295)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_807",
  "data-name": "Rectangle 807",
  width: 9.157,
  height: 2.817,
  transform: "translate(7.754 76.504)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_808",
  "data-name": "Rectangle 808",
  width: 54.943,
  height: 2.817,
  transform: "translate(7.754 22.269)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_809",
  "data-name": "Rectangle 809",
  width: 54.943,
  height: 2.817,
  transform: "translate(7.754 26.488)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_810",
  "data-name": "Rectangle 810",
  width: 54.943,
  height: 2.817,
  transform: "translate(7.931 38.992)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_811",
  "data-name": "Rectangle 811",
  width: 54.943,
  height: 2.817,
  transform: "translate(7.754 43.399)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_812",
  "data-name": "Rectangle 812",
  width: 42.262,
  height: 2.817,
  transform: "translate(7.754 47.63)",
  fill: "#e5e5e5"
}), React.createElement("rect", {
  id: "Rectangle_813",
  "data-name": "Rectangle 813",
  width: 18.314,
  height: 2.817,
  transform: "translate(7.754 30.719)",
  fill: "#e5e5e5"
}), React.createElement("line", {
  id: "Line_89",
  "data-name": "Line 89",
  x2: 18.314,
  transform: "translate(7.754 74.394)",
  fill: "#fff",
  stroke: "#e5e5e5",
  strokeWidth: 1
}), React.createElement("rect", {
  id: "Rectangle_814",
  "data-name": "Rectangle 814",
  width: 9.157,
  height: 2.817,
  transform: "translate(44.383 76.504)",
  fill: "#e5e5e5"
}), React.createElement("line", {
  id: "Line_90",
  "data-name": "Line 90",
  x2: 18.314,
  transform: "translate(44.383 74.394)",
  fill: "#fff",
  stroke: "#e5e5e5",
  strokeWidth: 1
})));

var SvgIconBuySingleRoles = function SvgIconBuySingleRoles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 184.623,
    height: 180.198,
    viewBox: "0 0 184.623 180.198",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBuySingleRoles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-buy-single-roles.a7eaceb5.svg";
export { ForwardRef as ReactComponent };